var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-3" }, [
      _c("div", { staticClass: "row m-0" }, [
        _c(
          "div",
          { staticClass: "col-md-4 p-0" },
          [
            _vm.dialogsLoading
              ? [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: {
                      loading: true,
                      color: _vm.$constants.LOADING_COLOR,
                    },
                  }),
                ]
              : [
                  _vm.dialogs && _vm.dialogs.length
                    ? [
                        _c("ChatList", {
                          attrs: {
                            dialogs: _vm.dialogs,
                            users: _vm.users,
                            displayDetails: {
                              orderId: true,
                              author:
                                _vm.$currentRole === "admin" ||
                                _vm.$currentUserRoles.includes("manager"),
                            },
                            onSelect: _vm.onSelectDialog,
                            selectedDialogId:
                              _vm.selectedDialog && _vm.selectedDialog.id,
                          },
                        }),
                      ]
                    : [_vm._m(0)],
                ],
          ],
          2
        ),
        _vm._v(" "),
        _vm.dialogs && _vm.dialogs.length
          ? _c(
              "div",
              { staticClass: "col-md-8 p-0 all_messages_block" },
              [
                _vm.selectedDialog && _vm.selectedDialog.id
                  ? [
                      _vm.selectedDialog
                        ? _c("div", { staticClass: "object_info" }, [
                            _c(
                              "div",
                              [
                                _vm.selectedDialog.object_id
                                  ? [
                                      _c("p", [
                                        _vm._v("Заявка "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.selectedDialog.object_id)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info ml-1 mr-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.orderToEdit(
                                                  _vm.selectedDialog.object_id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.selectedDialog.order
                                                .project_label
                                            )
                                          ),
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              (_vm.$AllCities[
                                                _vm.selectedDialog.order.city_id
                                              ] &&
                                                _vm.$AllCities[
                                                  _vm.selectedDialog.order
                                                    .city_id
                                                ].short_name) ||
                                                _vm.selectedDialog.order.city_id
                                            ) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              badge: true,
                                              "badge-warning":
                                                _vm.selectedDialog.order
                                                  .status < 0,
                                              "badge-info":
                                                _vm.selectedDialog.order
                                                  .status >= 0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedDialog.order
                                                  .status_label
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _vm.allowToClose
                                  ? _c("LoadingButton", {
                                      attrs: {
                                        title: "Решено",
                                        type: "button",
                                        loading: _vm.btnLoading,
                                        color: _vm.$constants.SUCCESS_COLOR,
                                        onClick: () => _vm.acceptDialog(true),
                                        className: "btn btn-outline-success",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedDialog &&
                      _vm.selectedDialog.id &&
                      _vm.activeMessages
                        ? _c("Messages", {
                            attrs: {
                              users: _vm.users,
                              allowToClose:
                                +_vm.selectedDialog.user_id === _vm.$currentUID,
                              dialogId: _vm.selectedDialog.id,
                              dialogAccepted:
                                +_vm.selectedDialog.user_id ===
                                  _vm.$currentUID ||
                                !!_vm.selectedDialog.is_accepted,
                              messages: _vm.activeMessages,
                            },
                          })
                        : _vm._e(),
                    ]
                  : [_c("center", [_c("h4", [_vm._v("Выберите запрос")])])],
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("У Вас нет активных диалогов")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }